/**
 * Яндекс Метрика — общий низкоуровневый доступ к счётчику.
 * Скрипт метрики грузится вне React, поэтому `window.ym` может отсутствовать
 * (ad-block, ещё не загрузился) — все вызовы молча no-op.
 */
export const YM_COUNTER_ID = 39917135;

/** Метрика не ответила — не держим пользователя дольше этого. */
const CALLBACK_TIMEOUT_MS = 500;

const call = (method: string, ...params: unknown[]): boolean => {
    try {
        if (typeof window.ym !== 'function') {
            return false;
        }
        window.ym(YM_COUNTER_ID, method, ...params);
        return true;
    } catch (e) {
        console.log('YM tracking error:', e);
        return false;
    }
};

/**
 * `callback` нужен, когда сразу после цели идёт редирект: он вызывается ровно
 * один раз — метрикой, либо по таймауту, либо сразу, если счётчика нет. Без
 * него навигация может убить ещё не ушедший запрос.
 */
export const reachGoal = (
    goal: string,
    params?: Record<string, unknown>,
    callback?: () => void,
): void => {
    if (!callback) {
        call('reachGoal', goal, params);
        return;
    }

    let done = false;
    const once = () => {
        if (done) return;
        done = true;
        callback();
    };

    if (!call('reachGoal', goal, params, once)) {
        once();
        return;
    }
    window.setTimeout(once, CALLBACK_TIMEOUT_MS);
};

export const firstPartyParams = (params: Record<string, unknown>): void => {
    call('firstPartyParams', params);
};
